import Dexie from 'dexie';
import { IReferenceLocalities } from '../Models/Reference';

export class LocalityDatabase extends Dexie {
    public arrondissements: Dexie.Table<IReferenceLocalities, number>;
    public communes: Dexie.Table<IReferenceLocalities, number>;
    public provinces: Dexie.Table<IReferenceLocalities, number>;
    public regions: Dexie.Table<IReferenceLocalities, number>;

    constructor() {
        super('LocalitiesDatabase');

        this.version(1).stores({
            arrondissements:
                '++id, communeId, arrondissementId, codePostal, libelle',
            communes: '++id, communeId, arrondissementId, codePostal, libelle',
            provinces: '++id, communeId, arrondissementId, codePostal, libelle',
            regions: '++id, communeId, arrondissementId, codePostal, libelle',
        });

        this.arrondissements = this.table('arrondissements');
        this.communes = this.table('communes');
        this.provinces = this.table('provinces');
        this.regions = this.table('regions');
    }
}
new LocalityDatabase();

export const localityDb = new LocalityDatabase();
